import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface MapPinIconProps {
  size?: number;
  color?: string;
}

export function MapPinIcon({ size = 16, color = '#676666' }: MapPinIconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4.51C8.71 4.51 9.39 4.79 9.89 5.29C10.39 5.79 10.67 6.46 10.67 7.17C10.67 7.88 10.39 8.56 9.89 9.06C9.39 9.56 8.71 9.84 8 9.84C7.29 9.84 6.61 9.56 6.11 9.06C5.61 8.56 5.33 7.88 5.33 7.17C5.33 6.46 5.61 5.79 6.11 5.29C6.61 4.79 7.29 4.51 8 4.51ZM8 5.84C7.65 5.84 7.31 5.98 7.06 6.23C6.81 6.48 6.67 6.82 6.67 7.17C6.67 7.53 6.81 7.86 7.06 8.11C7.31 8.36 7.65 8.51 8 8.51C8.35 8.51 8.69 8.36 8.94 8.11C9.19 7.86 9.33 7.53 9.33 7.17C9.33 6.82 9.19 6.48 8.94 6.23C8.69 5.98 8.35 5.84 8 5.84Z"
        fill={color}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.17C9.19 1.17 10.35 1.52 11.33 2.18C12.32 2.84 13.09 3.78 13.54 4.88C14 5.97 14.12 7.18 13.88 8.34C13.65 9.51 13.08 10.58 12.24 11.41L9.41 14.24C9.04 14.62 8.53 14.83 8 14.83C7.47 14.83 6.96 14.62 6.59 14.24L3.76 11.41C2.92 10.58 2.35 9.51 2.12 8.34C1.88 7.18 2 5.97 2.46 4.88C2.91 3.78 3.68 2.84 4.67 2.18C5.65 1.52 6.81 1.17 8 1.17ZM8 2.51C7.08 2.51 6.17 2.78 5.41 3.29C4.64 3.8 4.04 4.53 3.69 5.39C3.34 6.24 3.24 7.18 3.42 8.08C3.6 8.99 4.05 9.82 4.7 10.47L7.53 13.3L7.58 13.34C7.7 13.44 7.85 13.49 8 13.49C8.18 13.49 8.35 13.42 8.47 13.3L11.3 10.47C11.95 9.82 12.4 8.99 12.58 8.08C12.76 7.18 12.66 6.24 12.31 5.39C11.96 4.53 11.36 3.8 10.59 3.29C9.83 2.78 8.92 2.51 8 2.51Z"
        fill={color}
      />
    </Svg>
  );
}
